import { render, staticRenderFns } from "./NotificationCard.vue?vue&type=template&id=77166db0&scoped=true&"
import script from "./NotificationCard.vue?vue&type=script&lang=js&"
export * from "./NotificationCard.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCard.vue?vue&type=style&index=0&id=77166db0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77166db0",
  null
  
)

export default component.exports